import './home.css'
import './privacyserpapi.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import rankytanktitle from './assets/home/husholdtitle.png'
import serpapiwww1 from './assets/home/serpapiwww1.png'
import serpapiwww2 from './assets/home/serpapiwww2.png'
import husholdgotoserpapi from './assets/home/husholdgotoserpapi.png'

import searchwithserpapi1 from './assets/home/searchwithserpapi1.png'
import searchwithserpapi2 from './assets/home/searchwithserpapi2.png'
import searchwithserpapi3 from './assets/home/searchwithserpapi3.png'

import Footer from './footer'

function HusholdSerpAPI() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="rankytank" style={{ flex: 1, marginTop: '1vw' }}>
          <div>
            <a href="/hushold" className="woohooologo">
              <img className="husholdtitle2" src={rankytanktitle} />
            </a>
          </div>
          <div className="rankytanksubtitleprivacy" style={{ marginTop: '1vw', marginBottom: '1vw' }}>
            SerpAPI
          </div>
          {/* <img className="rankytanklogo" src={rankytanklogo} /> */}

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="privacy_description" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p className="pheader">Hvad er dette</p>
              <p className="ptext">
                SerpAPI er et tredjeparts-API, der gør det muligt at fremsøge billeder direkte i Hushold-appen, når du opretter produkter. Hushold kræver blot
                en SerpAPI-key og du er kørende.
              </p>

              <p className="pheader">Hov, er dette ikke lige lovlig reklameagtigt</p>
              <p className="ptext">
                Dette er ikke en reklame, eller dvs det er det jo... Men jeg tilbyder kun denne information for ikke selv at stå med omkostningen som igen ville
                blive sendt videre til forbrugerne.
              </p>

              <p className="pheader">Hvor får jeg dette</p>
              <p className="ptext">
                Ved at oprette en profil hos <a href="https://serpapi.com/">SerpAPI</a> kan få tilbudt en nøgle ganske gratis.
              </p>
              <div>
                <img className="serpapiwww1" src={serpapiwww1} />
                <img className="serpapiwww2" src={serpapiwww2} />
              </div>

              <p className="pheader">Begrænsninger</p>
              <p className="ptext">
                Med SerpAPI kan du via en gratis profil får mulighed for 250 stk billedsøgninger per måned. Det er helt op til dig, om du vil betale en lille
                sum til SerpAPI for at få mulighed for flere billedsøgninger per måned.
              </p>

              <p className="pheader">Hvordan tilknytter jeg SerpAPI nøgle med Hushold-appen</p>
              <p className="ptext">
                For at tilknytte din SerpAPI-nøgle skal du kopiere den fra SerpAPI-siden (under “Your private API key”) og indsætte den i Hushold-appen under
                Indstillinger, som vist nedenfor.
              </p>
              <div>
                <img className="husholdgotoserpapi" src={husholdgotoserpapi} />
              </div>

              <p className="pheader">Hvordan sørger jeg efter billeder til mine produkter i Hushold-appen</p>
              <p className="ptext">
                For at søge efter et billede kan du åbne et nyt eller eksisterende produkt og trykke på billedikonet under produktdetaljer (se nedenfor).
                <br /> <br />
                Produktnavnet bruges automatisk som søgekriterium, når du vælger “Vælg fra internet”. Det kan tage et øjeblik at hente resultaterne, hvorefter
                du frit kan vælge det billede, der passer bedst.
              </p>
              <div style={{ display: 'flex', gap: 5, flexWrap:'wrap', justifyContent: 'center' }}>
                <img className="searchwithserpapi1" src={searchwithserpapi1} />
                <img className="searchwithserpapi2" src={searchwithserpapi2} />
                <img className="searchwithserpapi3" src={searchwithserpapi3} />
              </div>
            </div>
          </div>
          {/* <div>
            <div>
              <div className="rankytankapplestore">
                <a href="https://apps.apple.com/us/app/rankytank/id1642592019">
                  <img src={wwwappstore15pct} />
                </a>
              </div>
              <div className="rankytankgoogleplay">
                <a href="https://play.google.com/store/apps/details?id=com.rankytank2">
                  <img src={wwwgoogleplay15pct} />
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', gap: 5, flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{}}>
                    <a href="/privacyhushold">
                      <img src={privacybutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/supporthushold">
                      <img src={supportbutton} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default HusholdSerpAPI
